let lastTrackedException;

INKIVE.C.IS_DEV || window.addEventListener('error', function (err) {
  if (lastTrackedException !== exception) {
    var exception = err.filename + ' [' + err.lineno + ']: ' + err.message;
    typeof ga === 'function' && ga('send', 'exception', { exDescription: exception });

    lastTrackedException = exception;
  }
}, false);
